import React, { Component } from 'react'
import styled from 'styled-components'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import R from 'ramda'
import moment from 'moment'
import { Form as UnstyledForm} from 'formsy-react-2'
import { Table, TableCell, TextIcon, TableHeader, TableLoading, TextInput, Select,
  Title, Title3, Colors, Button, Pagination, ContextMenu } from 'advenio-components'
import { connect } from 'react-redux'
import ProfileHeader from '../../Components/ProfileHeader'
import InvoiceDataForm from '../../Components/ParentComponents/InvoiceDataForm'
import { Col, FormContainer, Grid, Header, Row } from '../../Components/ParentComponents/ParentProfileForm'
import ReservationBmxActions from '../../Data/Redux/ReservationBmxRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CoursesActions from '../../Data/Redux/CoursesRedux'
import { parseFullName, formatPrice } from '../../utils/Utils'
import LoadingSpinner from '../../Components/LoadingSpinner'

const FormParent = styled.div`
  box-sizing: border-box;
  background: #fff;
  border: solid transparent 1px;
  border-radius: 5px;
`
const Form = styled(UnstyledForm)`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const Container = styled.div`
  padding: 54px;
`
const Courses = styled(Col)`
  margin: 10px 0px 15px 0px;
`
const CoursesHeader = styled.div`
  border-bottom: solid 1px ${Colors.gray400};
  margin-bottom: 5px;
`
const CoursesBody = styled.div`
  height: 210px;
`
const CoursesPrice = styled.div`
  display:Block;
  margin-top:7px;
`
const CoursesModule = styled.div`
  display:Block;
  margin-top:7px;
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`

class CoursesInfo extends Component {
  state = {
    typeModal: 'authorize',
    modalServiceOpen: false,
    pageSelected:1,
    queryParams: {},
    reservationId:0,
    modalResverationBmxOpen:false,
    student:null,
    parents:[],
    parent: {
      relation_id: null,
      nickname: '',
      contact_numbers: {
        phone_number: '',
        cellphone_number: '',
      },
      email:'',
      first_name: '',
      last_name_maternal: '',
      last_name_paternal: '',
      company_id: null,
      pays_automatically: false,
      requires_invoices: false,
    },
  }

  componentWillMount = () => {
    const { getCenterCourses, user } = this.props
    getCenterCourses(user.center_id)
  }

  componentWillReceiveProps = (nextProps) => {
    const { courses } = nextProps
    if(courses.length>0) {
      
    }
  }

  onSubmit = (data) => {
    console.log(data)
  }
  
  onFilter = (query) => {
    console.log(query)
  }
      
  navigateToProfile = (student) => {

  }
  changeSelect = ({target:{value}})=> { 
    console.log(value)

  }

  formatPayments = (payments) => (
    [{id:0,value:0,label:"Seleccione"}].concat(payments.map(p=>({
      id: p.id,
      value: p.id,
      label: `deposito $${p.amount} el ${p.paid_at}`
    })))
  )

  rednerCoruses = () => {
    const { courses } = this.props
    const patt = new RegExp(/.+?(?=[(])/)
    const mod = new RegExp(/[A-Za-z]*\s[(][A-Za-z]*[)]\s/)
    return courses.map( (c,index) => (
        <Courses key={index} sm={6} md={4} lg={4}>
          <CoursesHeader>
           <Title3 style={{fontSize:'1.5rem'}}>{c.consumable}</Title3> 
          </CoursesHeader>
          <CoursesBody>
           {c.description}
           <CoursesPrice><b>Precio:</b> {formatPrice(c.total_price,{symbol:'$'})}</CoursesPrice>
           {c.additional_consumables.map((m,index)=>(
              <CoursesModule key={index}>{m.module.replace(mod,'')} - <b>Precio:</b> {formatPrice(m.total_price,{symbol:'$'})}</CoursesModule>
            )
           )}
          </CoursesBody>
        </Courses>      
    ))
  }

  render() {
    const { centerProducts, studyPrograms, classrooms, meta,loading , courses} = this.props
    const { pageSelected, center, queryParams, parents, parent } = this.state
    if (loading || courses.length === 0){
      return <LoadingSpinner />
    }
    return (
      <Container>
        <HeaderContainer>
          <Title>Informacion de Cursos</Title>
        </HeaderContainer>
          <FormParent>
            <Row style={{padding:'10px 20px'}}>
            {this.rednerCoruses()}
            </Row>
          </FormParent>
      </Container>
    )
  }
}


CoursesInfo.defaultProps = {
  loading: false,
  reservations: [],
  meta: {},
  location: {},
  studentPayments:[],
}

const mapStateToProps = state => ({
  /** Error and loading for modal options */
    loading: state.courses.get.fetching,
    courses: state.courses.get.results,
    meta: state.reservationBmx.get.results,
    user: state.auth.user,
    loadingpost: state.reservationBmx.postReservation.fetching,
    loadingPayments:state.reservationBmx.studentPayments.fetching,
    studentPayments: state.reservationBmx.studentPayments.results
})

const mapDispatchToProps = dispatch => ({
  getCenterCourses: (centerId) => dispatch(CoursesActions.getRequest(centerId, true)),   
 goTo: path => dispatch(push(path)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CoursesInfo)



// WEBPACK FOOTER //
// ./src/Containers/Courses/CoursesInfo.jsx